/* eslint-disable max-len */
// based, but not exactly, on the one from
// https://www.hanselman.com/blog/InternationalizedRegularExpressions.aspx
export const NAME_RE = /^[A-Za-z-'.ÀÈÌÒÙàèìòùÁÉÍÓÚÝáéíóúýÂÊÎÔÛâêîôûÃÑÕãñõÄËÏÖÜŸäëïöüçÇŒœßØøÅåÆæÞþÐð ]*$/;

export const CITY_RE = /^[0-9A-Za-z-'.ÀÈÌÒÙàèìòùÁÉÍÓÚÝáéíóúýÂÊÎÔÛâêîôûÃÑÕãñõÄËÏÖÜŸäëïöüçÇŒœßØøÅåÆæÞþÐð ]*$/;

export const EMAIL_RE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
